import { render, staticRenderFns } from "./NewCompanyReport.vue?vue&type=template&id=4954855e"
import script from "./NewCompanyReport.vue?vue&type=script&lang=js"
export * from "./NewCompanyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports